import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { rem, math } from 'polished';
import { devWarning } from '@paypalcorp/pp-react-utils';

const flagData = {
 "countries": {
  "ad": "0.431",
  "ae": "0.862",
  "ag": "1.293",
  "ai": "1.724",
  "al": "2.155",
  "am": "2.586",
  "an": "3.017",
  "ao": "3.448",
  "ar": "3.879",
  "at": "4.310",
  "au": "4.741",
  "aw": "5.172",
  "az": "5.603",
  "ba": "6.034",
  "bb": "6.466",
  "be": "6.897",
  "bf": "7.328",
  "bg": "7.759",
  "bh": "8.190",
  "bi": "8.621",
  "bj": "9.052",
  "bm": "9.483",
  "bn": "9.914",
  "bo": "10.345",
  "br": "10.776",
  "bs": "11.207",
  "bt": "11.638",
  "bw": "12.069",
  "by": "12.500",
  "bz": "12.931",
  "c2": "13.362",
  "ca": "13.793",
  "cd": "14.224",
  "cg": "14.655",
  "ch": "15.086",
  "ci": "15.517",
  "ck": "15.948",
  "cl": "16.379",
  "cm": "16.810",
  "cn": "17.241",
  "co": "17.672",
  "cr": "18.103",
  "cv": "18.534",
  "cy": "18.966",
  "cz": "19.397",
  "de": "19.828",
  "dj": "20.259",
  "dk": "20.690",
  "dm": "21.121",
  "do": "21.552",
  "dz": "21.983",
  "ec": "22.414",
  "ee": "22.845",
  "eg": "23.276",
  "er": "23.707",
  "es": "24.138",
  "et": "24.569",
  "fi": "25.000",
  "fj": "25.431",
  "fk": "25.862",
  "fm": "26.293",
  "fo": "26.724",
  "fr": "27.155",
  "ga": "27.586",
  "gb": "28.017",
  "gd": "28.448",
  "ge": "28.879",
  "gf": "29.310",
  "gi": "29.741",
  "gl": "30.172",
  "gm": "30.603",
  "gn": "31.034",
  "gp": "31.466",
  "gr": "31.897",
  "gt": "32.328",
  "gw": "32.759",
  "gy": "33.190",
  "hk": "33.621",
  "hn": "34.052",
  "hr": "34.483",
  "hu": "34.914",
  "id": "35.345",
  "ie": "35.776",
  "il": "36.207",
  "in": "36.638",
  "is": "37.069",
  "it": "37.500",
  "jm": "37.931",
  "jo": "38.362",
  "jp": "38.793",
  "ke": "39.224",
  "kg": "39.655",
  "kh": "40.086",
  "ki": "40.517",
  "km": "40.948",
  "kn": "41.379",
  "kr": "41.810",
  "kw": "42.241",
  "ky": "42.672",
  "kz": "43.103",
  "la": "43.534",
  "lc": "43.966",
  "li": "44.397",
  "lk": "44.828",
  "ls": "45.259",
  "lt": "45.690",
  "lu": "46.121",
  "lv": "46.552",
  "ma": "46.983",
  "mc": "47.414",
  "md": "47.845",
  "me": "48.276",
  "mg": "48.707",
  "mh": "49.138",
  "mk": "49.569",
  "ml": "50.000",
  "mn": "50.431",
  "mq": "50.862",
  "mr": "51.293",
  "ms": "51.724",
  "mt": "52.155",
  "mu": "52.586",
  "mv": "53.017",
  "mw": "53.448",
  "mx": "53.879",
  "my": "54.310",
  "mz": "54.741",
  "na": "55.172",
  "nc": "55.603",
  "ne": "56.034",
  "nf": "56.466",
  "ng": "56.897",
  "ni": "57.328",
  "nl": "57.759",
  "no": "58.190",
  "np": "58.621",
  "nr": "59.052",
  "nu": "59.483",
  "nz": "59.914",
  "om": "60.345",
  "pa": "60.776",
  "pe": "61.207",
  "pf": "61.638",
  "pg": "62.069",
  "ph": "62.500",
  "pl": "62.931",
  "pm": "63.362",
  "pn": "63.793",
  "pt": "64.224",
  "pw": "64.655",
  "py": "65.086",
  "qa": "65.517",
  "re": "65.948",
  "ro": "66.379",
  "rs": "66.810",
  "ru": "67.241",
  "rw": "67.672",
  "sa": "68.103",
  "sb": "68.534",
  "sc": "68.966",
  "se": "69.397",
  "sg": "69.828",
  "sh": "70.259",
  "si": "70.690",
  "sj": "71.121",
  "sk": "71.552",
  "sl": "71.983",
  "sm": "72.414",
  "sn": "72.845",
  "so": "73.276",
  "sr": "73.707",
  "st": "74.138",
  "sv": "74.569",
  "sz": "75.000",
  "tc": "75.431",
  "td": "75.862",
  "tg": "76.293",
  "th": "76.724",
  "tj": "77.155",
  "tm": "77.586",
  "tn": "78.017",
  "to": "78.448",
  "tr": "78.879",
  "tt": "79.310",
  "tv": "79.741",
  "tw": "0.000",
  "tz": "80.603",
  "ua": "81.034",
  "ug": "81.466",
  "us": "81.897",
  "uy": "82.328",
  "va": "82.759",
  "vc": "83.190",
  "ve": "83.621",
  "vg": "84.052",
  "vn": "84.483",
  "vu": "84.914",
  "wf": "85.345",
  "ws": "85.776",
  "ye": "86.207",
  "yt": "86.638",
  "za": "87.069",
  "zm": "87.500",
  "zw": "87.931",
  "eu": "88.362",
  "af": "88.793",
  "as": "89.224",
  "bd": "89.655",
  "io": "90.086",
  "cf": "90.517",
  "cx": "90.948",
  "cc": "91.379",
  "gq": "91.810",
  "gh": "92.241",
  "gu": "92.672",
  "gg": "93.103",
  "ht": "93.534",
  "im": "93.966",
  "lb": "94.397",
  "je": "94.828",
  "lr": "95.259",
  "mo": "95.690",
  "mm": "96.121",
  "mp": "96.552",
  "pk": "96.983",
  "ps": "97.414",
  "pr": "97.845",
  "tl": "98.276",
  "tk": "98.707",
  "vi": "99.138",
  "uz": "99.569",
  "eh": "100.000"
 },
 "sprites": {
  "1x": {
   "url": "https://www.paypalobjects.com/paypal-ui/components/flags/1x.png",
   "width": 32,
   "height": 24
  },
  "2x": {
   "url": "https://www.paypalobjects.com/paypal-ui/components/flags/2x.png",
   "width": 64,
   "height": 48
  },
  "3x": {
   "url": "https://www.paypalobjects.com/paypal-ui/components/flags/3x.png",
   "width": 96,
   "height": 72
  }
 }
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var sysBorderRadiusSm = tokens.sysBorderRadiusSm,
      sysBorderThicknessNormal = tokens.sysBorderThicknessNormal,
      sysColorStructureDivider = tokens.sysColorStructureDivider,
      sysSizeIconSm = tokens.sysSizeIconSm,
      sysSizeIconMd = tokens.sysSizeIconMd;
  var countries = flagData.countries,
      sprites = flagData.sprites;
  var sprite1x = sprites['1x'];
  var sprite2x = sprites['2x'];
  var flagSprite1XUrl = sprite1x.url;
  var flagSprite2XUrl = sprite2x.url;
  var flagSprite1XWidth = rem(sprite1x.width);
  var flagSprite1XHeight = rem(sprite1x.height);
  var flagSprite2XWidth = rem(sprite2x.width);
  var flagSprite2XHeight = rem(sprite2x.height);
  var flagWidth = {
    sm: sysSizeIconSm,
    md: sysSizeIconMd
  };

  var countryScale = function (size) {
    var density = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1x';
    var calculatedVal = math("".concat(flagWidth[size], " / ").concat(density === '1x' ? flagSprite1XWidth : flagSprite2XWidth));
    return parseFloat(calculatedVal);
  };

  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: flag;\n    display: inline-block;\n    box-sizing: border-box;\n    position: relative;\n  "])));

  var flagSize = function (size) {
    var sizeLabel = "size_".concat(size);
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      label: ", ";\n      width: ", ";\n      height: ", ";\n    "])), sizeLabel, flagWidth[size], math("".concat(flagWidth[size], " * ").concat(3 / 4)));
  };

  var scale = function (size, noRoundCorners) {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      label: ", ";\n      width: ", ";\n      height: ", ";\n      background: transparent url(", ") no-repeat;\n      background-size: cover;\n      background-origin: border-box;\n      transform-origin: top left;\n      position: absolute;\n      left: 0;\n      border: ", " solid ", ";\n      transform: scale(", ");\n      border-radius: ", ";\n      @media only screen and (min-device-pixel-ratio: 2),\n        only screen and (min-resolution: 192dpi),\n        only screen and (min-resolution: 2dppx) {\n        width: ", ";\n        height: ", ";\n        background-image: url(", ");\n        transform: scale(", ");\n        border-radius: ", ";\n      }\n    "])), noRoundCorners ? 'scale_no_border' : 'scale', flagSprite1XWidth, flagSprite1XHeight, flagSprite1XUrl, sysBorderThicknessNormal, sysColorStructureDivider, countryScale(size), noRoundCorners ? 0 : math("".concat(sysBorderRadiusSm, "/").concat(countryScale(size))), flagSprite2XWidth, flagSprite2XHeight, flagSprite2XUrl, countryScale(size, '2x'), noRoundCorners ? 0 : math("".concat(sysBorderRadiusSm, "/").concat(countryScale(size, '2x'))));
  };

  var flag = function (countryCode) {
    if (!countryCode) {
      return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        label: flag_default;\n        background-position: 0 0%;\n      "])));
    }

    var country = countryCode.toLocaleLowerCase(); // @ts-ignore

    var backgroundPosition = countries[country] || 0;
    var flagLabel = backgroundPosition ? "flag_".concat(country) : "flag_default";
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      label: ", ";\n      // We are using percentage value to support text-scaling.\n      // In case flag sprite gets changed, it needs to be deployed as a brand-new URL\n      //without replacing the old file for backward-compatibility\n      background-position: 0 ", "%;\n    "])), flagLabel, backgroundPosition);
  };

  return {
    base: base,
    flagSize: flagSize,
    scale: scale,
    flag: flag
  };
}

var _excluded = ["countryCode", "size", "noRoundCorners", "className"];

var Flag = function (_ref) {
  var _styles$flagSize, _styles$scale, _styles$flag;

  var countryCode = _ref.countryCode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'sm' : _ref$size,
      _ref$noRoundCorners = _ref.noRoundCorners,
      noRoundCorners = _ref$noRoundCorners === void 0 ? false : _ref$noRoundCorners,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var containerCssVal = [_styles.base, (_styles$flagSize = _styles.flagSize) === null || _styles$flagSize === void 0 ? void 0 : _styles$flagSize.call(_styles, size)];
  var flagCssVal = [(_styles$scale = _styles.scale) === null || _styles$scale === void 0 ? void 0 : _styles$scale.call(_styles, size, noRoundCorners), (_styles$flag = _styles.flag) === null || _styles$flag === void 0 ? void 0 : _styles$flag.call(_styles, countryCode)];
  return jsx("div", _extends({
    css: containerCssVal,
    className: className,
    "data-ppui-info": "flag_2.21.0"
  }, rest), jsx("span", {
    css: flagCssVal,
    "data-ppui": "true"
  }));
};

export { Flag, styles as flagStyles };
